import ContractsCargoTaxiAddRequest, {
  ContractsCargoTaxiAddRequestModel,
} from "../../../../api/raily/contracts/cargo-taxi/add/contracts-cargo-taxi-add.request";
import BillingModel from "../../../../types/billing-model";
import ContractsCargoTaxiAddParams from "./contracts-cargo-taxi-add-params";

const createBillingModel = (
  billingModel: BillingModel,
): ContractsCargoTaxiAddRequestModel => {
  switch (billingModel) {
    case BillingModel.AB:
      return ContractsCargoTaxiAddRequestModel.AB;
    case BillingModel.ABA:
      return ContractsCargoTaxiAddRequestModel.ABA;
    case BillingModel.OTHER:
      return ContractsCargoTaxiAddRequestModel.OTHER;
    case BillingModel.SABS:
      return ContractsCargoTaxiAddRequestModel.SABS;
  }
};

const create = (
  params: ContractsCargoTaxiAddParams,
): ContractsCargoTaxiAddRequest => {
  return {
    allowChargeDuringRide: params.isTollRoadsDuringOrderAllowed,
    allowChargeWhileApproaching: params.isTollRoadsWhileArrivalAllowed,
    allowChargeWhileReturning: params.isTollRoadsWhileReturningAllowed,
    cargoCompanyId: params.cargoCompanyUuid,
    disabled: !params.isActive,
    discountLimit: params.discountPercentLimit,
    distanceRate: params.distanceRate,
    haltingTimeAfterMinutes: params.freeStoppingPeriodMinutes,
    haltingTimeRate: params.stoppingRate,
    model: createBillingModel(params.billingModel),
    publishingAllowed: params.isOrderPublishingAllowed,
    taxiCorporationId: params.taxiCorporationUuid,
    validSince: params.periodOfValidity.from,
    validTo: params.periodOfValidity.to,
    contactPassengerAfterMinutes: params.contactPassengerAfterMinutes,
    cancelOrderByTaxiAllowed: params.cancelOrderByTaxiAllowed,
    editOrderByTaxiAllowed: params.editOrderByTaxiAllowed,
    autoApprovalMinDistance: params.autoApprovalMinDistance,
    autoApprovalSwitch: params.autoApprovalSwitch,
    autoApprovalMinTime: params.autoApprovalMinTime,
    approvalDeadlineSwitch: params.approvalDeadlineSwitch,
    approvalDeadlineTime: params.approvalDeadlineTime,
  };
};

const contractsCargoTaxiAddParamsFactory = {
  create,
};

export default contractsCargoTaxiAddParamsFactory;
